import { useState, 
        useEffect, 
        useRef, 
        useCallback } from 'react'
import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import Dialog            from '@mui/material/Dialog'
import DialogActions     from '@mui/material/DialogActions'
import DialogContent     from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle       from '@mui/material/DialogTitle'
import Button            from '@mui/material/Button'
import axios             from 'axios'
import store             from '../../store'
import '../../App.css'
import '../../style.css'
import {MUSIC_GAME,
        MUSIC_POKEMON_KANJI_BATLE,
        MUSIC_POKEMON_KANJI_VICTORY,
        IMG_MONSTER_BALL,
        IMG_SUPER_BALL,
        IMG_HYPER_BALL,
        IMG_MASTER_BALL,
        IMG_MAIN_CHAR_BG,
        IMG_BALL_ON,
        IMG_BALL_NONE,} from '../Contants'
import ZukanSavedDialog from "./Dialog"

function Typing() {
    const [pokemonImage   , setPokemonImage   ] = useState()      // ポケモン画像表示
    const [pokemonname    , setPokemonName    ] = useState("")    // ポケモンの名前
    const [pokemonhight   , setPokemonHight   ] = useState()      // ポケモンの高さ
    const [pokemonweight  , setPokemonWeight  ] = useState()      // ポケモンの重さ
    const [pokemontext    , setPokemonText    ] = useState()      // ポケモンの説明文
    const [pokemonid      , setPokemonID      ] = useState()      // ポケモンのNo
    const [pokemongenus   , setPokemonGenus   ] = useState()      // ポケモンの分類
    const [pokemonLevel   , setPokemonLevel   ] = useState()      // ポケモンのレベル
    const [pokemonHP      , setPokemonHP      ] = useState()      // ポケモンのHP
    const [resultWord     , setResultWord     ] = useState()      // 正解の判定
    const [errType        , setErrType        ] = useState()      // ミスの判定
    const [fontColor      , setFontColor      ] = useState()      // フォントカラー
    const [count          , setCount          ] = useState(1)     // 問題数
    const [dialogopen     , setDialogOpen     ] = useState(false) // ダイアログ表示の状態管理
    const [correctCount   , setCorrectCount   ] = useState(0)     // 正解の数
    const [getPokemonList , setGetPokemonList ] = useState([])    // 正解したポケモンの画像を格納する配列
    const [resultStroke   , setResultStroke   ] = useState()      // 画数の答え
    const [pokemonRomaji  , setPokemonRomaji  ] = useState("")    // ポケモン名（ローマ字）

    // 図鑑保存ダイアログ用
    const [savedDialogOpen, setSavedDialogOpen] = useState(false)
    const [savedDialogMessage, setSavedDialogMessage] = useState("図鑑に登録しました。")

    // タイマー（60秒）
    const [timeLeft, setTimeLeft] = useState(60)
    const timerRef = useRef(null)
    // 音楽が流れる
    const [gameMusic]       = useState(new Audio(MUSIC_GAME))
    const [battleAudio]     = useState(new Audio(MUSIC_POKEMON_KANJI_BATLE))
    const [pokemonVictory ] = useState(new Audio(MUSIC_POKEMON_KANJI_VICTORY))
    // タイピング用
    const [cursor    , setCursor    ] = useState(0) // 何文字目まで正解したか
    const [missCount , setMissCount ] = useState(0) // ミス数（任意）
    const typingAreaRef = useRef(null)              // キー入力を受けるためのフォーカス用

    // 初期値に戻す
    const initialize = () => {
        setPokemonImage("")
        setPokemonName("")
        setCount(1)
        setFontColor("")
        setResultWord("")
        setErrType("")
        setCorrectCount(0)
        setGetPokemonList([])
    }

    // ポケモンAPIを呼び出す
    const fetchPokemonImages = async () => {
        // ポケモンAPIを呼び出す
        const randomNumber = Math.floor(Math.random() * 898) + 1
        // const randomNumber = Math.floor(474)

        // ポケモンAPIを呼び出す
        const response = await axios.get("https://pokeapi.co/api/v2/pokemon/" + randomNumber)
        const speciesUrl = response.data.species.url
        const speciesResponse = await axios.get(speciesUrl)

        // ポケモンの画像を取得
        setPokemonImage(response.data.sprites.front_default || "")

        // ポケモンの名前を取得
        const japaneseName =
            speciesResponse.data.names.find(n => n.language.name === "ja")?.name
            || response.data.name
            || ""
        setPokemonName(japaneseName)

        // ローマ字表示用：カナ表記（ja-Hrkt）を優先してローマ字に変換する
        const kanaName =
            speciesResponse.data.names.find(n => n.language.name === "ja-Hrkt")?.name
            || japaneseName
        setPokemonRomaji(kanaToRomaji(kanaName))
        console.log(kanaName)

        // ポケモンのHPを設定
        setPokemonHP(Math.floor(Math.random() * 100) + 1)

        // ポケモンのレベルを設定
        setPokemonLevel(Math.floor(Math.random() * 100) + 1)

        // 高さを取得
        setPokemonHight(response.data.height)

        // 重さを取得
        setPokemonWeight(response.data.weight)

        // Noを取得
        setPokemonID(response.data.id)

        // 分類を取得
        const genera = speciesResponse.data.genera || []
        const genusObj =
            genera.find(v => v?.language?.name === "ja-Hrkt") ||
            genera.find(v => v?.language?.name === "ja") ||
            genera.find(v => v?.language?.name === "en")
        setPokemonGenus(genusObj?.genus ?? "")

        // 説明文取得
        const flavorTextEntries = speciesResponse.data.flavor_text_entries
        console.log(flavorTextEntries)
        let flavorText = flavorTextEntries.filter(function(v) {
            return (v.language.name == "ja-Hrkt") && (v.version.name == "sword")
        })

        if (flavorText.length == 0) {
            // バージョンをYで取得し直す.
            flavorText = flavorTextEntries.filter(function(v) {
                return (v.language.name == "ja-Hrkt") && (v.version.name == "y")
            })
        }
        if (flavorText.length == 0) {
            // バージョンをサンで取得し直す.
            flavorText = flavorTextEntries.filter(function(v) {
                return (v.language.name == "ja-Hrkt") && (v.version.name == "sun")
            })
        }
        if (flavorText.length == 0) {
            // バージョンをウルトラサンで取得し直す.
            flavorText = flavorTextEntries.filter(function(v) {
                return (v.language.name == "ja-Hrkt") && (v.version.name == "ultra-sun")
            })
        }
        const cleanedText = flavorText?.[0]?.flavor_text || "ポケモンのデータがありませんでした。"
        setPokemonText(cleanedText)
    }
    
    const [booted    , setBooted] = useState(false)
    const [bootError , setBootError] = useState("")
    const [booting   , setBooting] = useState(false)

    // タイマーを開始する
    const startTimer = () => {
        stopTimer()
        setTimeLeft(60)

        timerRef.current = setInterval(() => {
            setTimeLeft((prev) => {
            if (prev <= 1) {
                // 0になったら止める
                stopTimer()
                return 0
            }
            return prev - 1
            })
        }, 1000)
    }

    // タイマーを止める
    const stopTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current)
            timerRef.current = null
        }
    }
    
    // audio.play() は失敗することがある（自動再生ブロック等）ので握りつぶす
    const safePlay = async (audioObj) => {
        try {
            audioObj.currentTime = 0
            await audioObj.play()
        } catch (e) {
            console.warn("audio play blocked:", e)
        }
    }

    // ゲーム開始処理
    const startGame = useCallback(async () => {
        if (booted || booting) return
        setBooting(true)
        setBootError("")

        try {
            // 先にポケモン取得（表示が最優先）
            await fetchPokemonImages()

            // タイマー開始
            startTimer()

            // BGM（失敗しても止めない）
            gameMusic.pause()
            battleAudio.pause()
            pokemonVictory.pause()
            await safePlay(battleAudio)

            setBooted(true)
            typingAreaRef.current?.focus()
        } catch (e) {
            console.error(e)
            stopTimer()
            setBootError("ポケモンの読み込みに失敗したよ…（通信エラーの可能性）")
        } finally {
            setBooting(false)
        }
    }, [
        booted,
        booting,
        fetchPokemonImages,
        startTimer,
        stopTimer,
        safePlay,
        gameMusic,
        battleAudio,
        pokemonVictory,
    ])

    // 起動時の処理
    useEffect(() => {
        // ゲーム開始
        startGame()
        // 1秒待ってからフォーカス
        const focusTimer = setTimeout(() => {
            typingAreaRef.current?.focus()
        }, 1000)
        return () => {
            stopTimer()
            gameMusic.pause()
            battleAudio.pause()
            pokemonVictory.pause()
        }
    }, [])

    // タイマーが0になったらダイアログを開く
    useEffect(() => {
        if (timeLeft === 0 && !dialogopen) {
            // ダイアログを開く
            handleDialogOpen()
        }
    }, [timeLeft])
    
    // ポケモン名が変わったらローマ字をリセット
    useEffect(() => {
        setCursor(0)
        setResultWord("")
        setErrType("")
        setFontColor("")
    }, [pokemonRomaji])

    // キー入力の正規化
    const normalizeKey = (key) => {
        if (typeof key !== "string") return key

        // ① 全角英数字を半角へ（０-９ / Ａ-Ｚ / ａ-ｚ）
        key = key.replace(/[０-９Ａ-Ｚａ-ｚ]/g, (ch) =>
            String.fromCharCode(ch.charCodeAt(0) - 0xFEE0)
        )

        // ② 大文字小文字を無視（←これで Ｚ → z になる）
        key = key.toLowerCase()

        // ③ 揺れ対策（必要なら増やす）
        if (key === "’") key = "'"  // 全角アポストロフィ
        if (key === "－") key = "-" // 全角ハイフン
        if (key === "：") key = ":" // 全角コロン

        return key
    }

    // キー入力処理
    const handleKeyDown = useCallback((e) => {
        if (dialogopen || timeLeft <= 0) return
        if (!pokemonRomaji) return
        if (e.isComposing) return
        if (e.key.length !== 1) return

        const key = normalizeKey(e.key)
        const target = pokemonRomaji
        const expected = normalizeKey(target[cursor])

        if (key === expected) {
            const next = cursor + 1
            setCursor(next)

            if (next >= target.length) {
            handleTypedComplete()
            }
            return
        }

        setMissCount((prev) => prev + 1)
        // setFontColor("blue")
        // setResultWord("ちがうよ！")
        setFontColor("blue")
        setErrType("ちがうよ！")
        setTimeout(() => setErrType(""), 300)
    }, [dialogopen, timeLeft, pokemonRomaji, cursor])

    // タイピング完了時の処理
    const handleTypedComplete = () => {
        setResultWord("せいかい！GET！！")
        setFontColor("red")

        // 図鑑用のポケモンデータを作成
        const newPokemon = {
            id     : pokemonid,
            name   : pokemonname,
            image  : pokemonImage,
            height : pokemonhight,
            weight : pokemonweight,
            genus  : pokemongenus,
            text   : pokemontext,
            mode   : "typing",
            grade  : store.getState().GakunenSelect,
            kanji  : null, // タイピングなのでnullでOK
        }

        // 図鑑に追加
        setGetPokemonList((prev) => [...prev, newPokemon])
        setCorrectCount((prev) => prev + 1)

        // 次のポケモンを呼び出す
        setTimeout(() => {
            setResultWord("")
            setErrType("")
            fetchPokemonImages()
        }, 600)
    }

    /**
     * カタカナ/ひらがな → ローマ字（簡易版）
     * - 「ー」は母音を伸ばさず「-」で表現する（例: タネボー → tanebo-）
     * - 表示を小文字に統一する（例: Taneboo → tanebo-）
     */
    const kanaToRomaji = (input = "") => {
        if (!input) return ""

        // ★追加：性別記号（♀/♂）を空文字扱いにする
        input = input.replace(/[♀♂・]/g, "")

        // 1) カタカナ→ひらがなに寄せる（マップをひらがな基準にするため）
        const toHiragana = (str) => {
            return str.replace(/[\u30A1-\u30F6]/g, (ch) => {
            return String.fromCharCode(ch.charCodeAt(0) - 0x60)
            })
        }

        const s = toHiragana(input)

        // 2) 拗音マップ（2文字で1音）
        const digraphMap = {
            きゃ: "kya", きゅ: "kyu", きょ: "kyo",
            ぎゃ: "gya", ぎゅ: "gyu", ぎょ: "gyo",
            しゃ: "sha", しゅ: "shu", しょ: "sho",
            じゃ: "ja",  じゅ: "ju",  じょ: "jo",
            ちゃ: "cha", ちゅ: "chu", ちょ: "cho",
            にゃ: "nya", にゅ: "nyu", にょ: "nyo",
            ひゃ: "hya", ひゅ: "hyu", ひょ: "hyo",
            びゃ: "bya", びゅ: "byu", びょ: "byo",
            ぴゃ: "pya", ぴゅ: "pyu", ぴょ: "pyo",
            みゃ: "mya", みゅ: "myu", みょ: "myo",
            りゃ: "rya", りゅ: "ryu", りょ: "ryo",
            ふぁ: "fa",  ふぃ: "fi",  ふぇ: "fe",  ふぉ: "fo",
            てぃ: "ti",  でぃ: "di",  とぅ: "tu",  どぅ: "du",
            うぁ: "wa",  うぃ: "wi",  うぇ: "we",  うぉ: "wo",
            しぇ: "she", ちぇ: "che", じぇ: "je",
            つぁ: "tsa", つぃ: "tsi", つぇ: "tse", つぉ: "tso",
        }

        // 3) 単体マップ（1文字で1音）
        const monoMap = {
            あ:"a",  い:"i",  う:"u",  え:"e",  お:"o",
            か:"ka", き:"ki", く:"ku", け:"ke", こ:"ko",
            さ:"sa", し:"shi",す:"su", せ:"se", そ:"so",
            た:"ta", ち:"chi",つ:"tsu",て:"te", と:"to",
            な:"na", に:"ni", ぬ:"nu", ね:"ne", の:"no",
            は:"ha", ひ:"hi", ふ:"fu", へ:"he", ほ:"ho",
            ま:"ma", み:"mi", む:"mu", め:"me", も:"mo",
            や:"ya", ゆ:"yu", よ:"yo",
            ら:"ra", り:"ri", る:"ru", れ:"re", ろ:"ro",
            わ:"wa", を:"wo",
            が:"ga", ぎ:"gi", ぐ:"gu", げ:"ge", ご:"go",
            ざ:"za", じ:"ji", ず:"zu", ぜ:"ze", ぞ:"zo",
            だ:"da", ぢ:"ji", づ:"zu", で:"de", ど:"do",
            ば:"ba", び:"bi", ぶ:"bu", べ:"be", ぼ:"bo",
            ぱ:"pa", ぴ:"pi", ぷ:"pu", ぺ:"pe", ぽ:"po",
            ぁ:"a",  ぃ:"i",  ぅ:"u",  ぇ:"e",  ぉ:"o",
            ゃ:"ya", ゅ:"yu", ょ:"yo",
            ゔ:"vu",
        }

        // 4) 変換ループ
        let result = ""
        let i = 0

        while (i < s.length) {
            const ch = s[i]
            const next = s[i + 1] || ""

            // 促音（小さい「っ」）→ 次の子音を重ねる
            if (ch === "っ") {
                const two = s.slice(i + 1, i + 3)
                const nextRoma = digraphMap[two] || monoMap[next] || ""
                if (nextRoma) result += nextRoma[0]
                i += 1
                continue
            }

            // 長音「ー」→ ハイフンにする
            if (ch === "ー") {
                result += "-"
                i += 1
                continue
            }

            // 拗音（2文字で1音）
            const two = s.slice(i, i + 2)
            if (digraphMap[two]) {
                result += digraphMap[two]
                i += 2
                continue
            }

            // 「ん」→ 次が母音/ y のときは "nn"
            if (ch === "ん") {
                const afterTwo = s.slice(i + 1, i + 3)
                const afterRoma = digraphMap[afterTwo] || monoMap[next] || ""
                result += (afterRoma && /^[aiueoy]/.test(afterRoma)) ? "nn" : "nn"
                i += 1
            continue
            }

            // 単体変換（マップにないものはそのまま）
            result += monoMap[ch] || ch
            i += 1
        }

        // 小文字に統一
        return result.toLowerCase()
    }

    // バトル音楽を再生
    const startPokemonBatlePlay = () => {
        gameMusic.pause()       // 停止
        battleAudio.pause()     // 停止
        pokemonVictory.pause()  // 停止
        battleAudio.currentTime = 0 // 常に先頭から再生
        // 1秒待機する
        setTimeout(() => {
        battleAudio.play() // 再生
        }, 500) // 500ミリ秒 = 0.5秒待機
    }

    // 勝利音楽を再生
    const startPokemonVictoryPlay = () => {
        gameMusic.pause()       // 停止
        battleAudio.pause()     // 停止
        pokemonVictory.pause()  // 停止
        pokemonVictory.currentTime = 0 // 常に先頭から再生
        // 1秒待機する
        setTimeout(() => {
        pokemonVictory.play() // 再生
        }, 500) // 500ミリ秒 = 0.5秒待機
    }

    // 音楽をすべて停止
    const AllMusicPause = () => {
        gameMusic.pause()       // 停止
        battleAudio.pause()     // 停止
        pokemonVictory.pause()  // 停止
    }

    // // テキストボックスの内容
    // const handleChange = (event) => {
    //     // 入力された値が数字でない場合は削除します
    //     const inputValue = event.target.value.replace(/[^0-9]/g, '')
    // }

    // // 答えが入力された時の処理
    // const handleKeyPressResult = (event) => {
    //     if (event.key === 'Enter') {
    //     console.log("入力値 => ",event.target.value)
        
    //     if (event.target.value == resultStroke) {
    //         console.log("正解")
    //         setResultWord("せいかい！GET！！")  // 結果のメッセージ
    //         setFontColor("red")                // フォントカラー設定

    //         // 図鑑用のポケモンデータを作成
    //         const newPokemon = {
    //         id     : pokemonid  , // 漢字ゲームなので null にしておく
    //         name   : pokemonname, // ポケモン名
    //         image  : pokemonImage,// 画像
    //         height : pokemonhight  ,
    //         weight : pokemonweight ,
    //         genus  : pokemongenus  ,
    //         text   : pokemontext   ,
    //         mode   : 'kokugo',                             // どのモードでゲットしたか
    //         grade  : store.getState().GakunenSelect,       // 学年
    //         }

    //         // // 配列に加える
    //         setGetPokemonList(prevList => {
    //         const newList = [...prevList, newPokemon];
    //         console.log("getPokemonList : ", newList, newList.length)
    //         return newList
    //         })

    //         setCorrectCount(correctCount + 1)  // 正解数を増加
    //         setPokemonImage(IMG_MONSTER_BALL)  // 画像をモンスターボールに変更
    //     } else {
    //         console.log("不正解")
    //         setFontColor("blue")              // フォントカラー設定
    //         setResultWord("にげられた。。。")  // 結果メッセージ
    //     }

    //     // カウントアップ
    //     setCount(count+1)
    //     console.log("count => " , count)
    //     // 10問で終了、終了後は処置期画面へ
    //     if(count == 10){
    //         // 2秒待機する
    //         setTimeout(() => {
    //         console.log("終了")

    //         // ダイアログを表示する
    //         handleDialogOpen(true)

    //         }, 1000); // 2000ミリ秒 = 2秒待機
    //     }else{
    //         // // 選択した学年情報の取得
    //         // getGakunenInfo()

    //         // ポケモンを再取得
    //         fetchPokemonImages()

    //         // 2秒待機する
    //         setTimeout(() => {
    //         setResultWord("")
    //         }, 2000) // 2000ミリ秒 = 2秒待機
    //     }
    //     }
    // }

    // ダイアログを開く
    const handleDialogOpen = () => {
        setDialogOpen(true)
        // タイマーを停止
        stopTimer()
        // 勝利音楽を再生
        startPokemonVictoryPlay()
    }

    // ダイアログを閉じる
    // もう一度ゲームをやる
    const handleGameReturn = () => {
        setDialogOpen(false)
        // 初期状態に戻す
        initialize(true)

        // バトル音楽を再生
        startPokemonBatlePlay()

        // ポケモンを呼び出す
        fetchPokemonImages()

        // タイマーを開始
        startTimer()
        // フォーカスを1秒後に戻す
        setTimeout(() => {
            typingAreaRef.current?.focus()
        }, 1000)
    }

    // ダイアログを閉じる
    // リフレッシュする
    const handleGameReflesh = () => {
        setDialogOpen(false)
        // 初期状態に戻す
        initialize(true)

        window.location.reload() // 画面をリフレッシュする
    }

    // ローカルストレージに保存
    const handleSaveLocalStrage = () => {

        // 初期状態でローカルストレージから既存のデータを取得
        let existingPokemonData
        try {
            existingPokemonData = JSON.parse(localStorage.getItem('pokemondata'))
            // データがnullの場合や配列でない場合、空の配列を設定
            if (!Array.isArray(existingPokemonData)) {
                existingPokemonData = []
            }
            } catch (error) {
            console.error("データ取得に失敗しました。：", error)
            existingPokemonData = []
        }

        // ポケモンリストを追加する処理
        for (var i = 0; i < getPokemonList.length; i++) {
            // 既存のデータに新しいデータを追加
            existingPokemonData.push(getPokemonList[i])
        }

        // 更新されたデータを一度だけローカルストレージに保存
        try {
            localStorage.setItem('pokemondata', JSON.stringify(existingPokemonData))
            // 保存完了ダイアログを表示
            setSavedDialogMessage("図鑑に登録しました。")
            setSavedDialogOpen(true)
        } catch (error) {
            console.error("Failed to save data to localStorage:", error)
            // 失敗時の表示
            setSavedDialogMessage("保存に失敗しました…")
            setSavedDialogOpen(true)
        }

        // 最終的なデータをコンソールに出力
        console.log(existingPokemonData)
    }

    return (
        <Box sx={{ m : 1 , p : 4}}>
            {/* ダイアログの表示領域 */}
            <ZukanSavedDialog
            open={savedDialogOpen}
            message={savedDialogMessage}
            onClose={() => setSavedDialogOpen(false)}
            />
            {/* 画面 */}
            <Paper
                ref={typingAreaRef}
                tabIndex={0}
                onClick={() => {
                    typingAreaRef.current?.focus()
                    if (!booted) startGame()
                }}
                onKeyDown={(e) => {
                    if (!booted) {
                    if (e.key === " " || e.key === "Enter") {
                        e.preventDefault()
                        startGame()
                    }
                    return
                    }
                    handleKeyDown(e)
                }}
                sx={{ m: 1, p: 1 ,
                    bgcolor      : '#f5f5dc'  ,
                    borderRadius : "1px"      , 
                    height       : "250px"    ,
                    width        : '250px'    ,
                    position     : 'absolute' , // 絶対位置指定
                    top          : '20px'     , // 縦位置を50pxに指定
                    left         : '40px'     , // 横位置を20pxに指定
            }}>

            {/* ダイアログ表示 */}
            <Dialog
                open={dialogopen}
                onClose={handleGameReturn}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    <Grid container spacing={2}>
                        <Grid item xs={1} align="right">
                        <img
                            src    = {IMG_MONSTER_BALL}
                            width  = "50px"
                            height = "50px"/>
                        </Grid>
                        <Grid item xs={10} align="center">
                        <Typography
                            sx={{
                            // 独自フォントに設定
                            fontFamily   : 'DotGothic16'   , // Kalamフォント
                            fontSize     : "25px"    , 
                            color        : '#000000' , // フォントの色を黒に設定
                            }}>うまく入力できたかな？
                        </Typography>
                        </Grid>
                        <Grid item xs={1} align="left">
                        <img
                            src    = {IMG_MONSTER_BALL}
                            width  = "50px"
                            height = "50px"/>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Grid container spacing={2}>
                        <Grid item xs={12} align="center">
                            <Typography
                            sx={{
                            // 独自フォントに設定
                            fontFamily   : 'DotGothic16'   , // Kalamフォント
                            fontSize     : "16px"    , 
                            color        : '#000000' , // フォントの色を黒に設定
                            }}>正しく入力できたかず
                            </Typography>
                        </Grid>
                        <Grid item xs={12} align="center">
                            <Typography
                            sx={{
                            // 独自フォントに設定
                            fontFamily   : 'DotGothic16'   , // Kalamフォント
                            fontSize     : "27px"    , 
                            color        : '#000000' , // フォントの色を黒に設定
                            }}>{correctCount} 匹
                            </Typography>
                        </Grid>
                        <Grid item xs={12} align="center">
                        <Typography
                            sx={{
                            // 独自フォントに設定
                            fontFamily   : 'DotGothic16'   , // Kalamフォント
                            fontSize     : "16px"    , 
                            color        : '#000000' , // フォントの色を黒に設定
                            }}>↓↓↓↓↓ゲットしたポケモン↓↓↓↓↓</Typography>
                        </Grid>
                        {/* ポケモン画像表示 */}
                        {getPokemonList.map((p , index) => (
                            <Grid item xs = {3} align="center">
                                <Button>
                                    <img
                                    key    = {index}
                                    src    = {p.image}
                                    width  = "130px"
                                    />
                                </Button>
                            </Grid>
                        ))}
                        </Grid>
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Grid container spacing={2}>
                        <Grid item xs = {4} align="center">
                            <Button onClick={handleGameReflesh}>
                            <img
                            src    = {IMG_SUPER_BALL}
                            width  = "50px"
                            height = "50px"/>
                            </Button>
                            <Typography
                            sx={{
                            // 独自フォントに設定
                            fontFamily   : 'DotGothic16'   , // Kalamフォント
                            fontSize     : "16px"    , 
                            color        : '#000000' , // フォントの色を黒に設定
                            }}>はじめのがめん</Typography>
                        </Grid>

                        <Grid item xs = {4} align="center">
                            <Button 
                            onClick={handleGameReturn} >
                            <img
                                src    = {IMG_HYPER_BALL}
                                width  = "50px"
                                height = "50px"/>
                            </Button>
                            <Typography
                            sx={{
                            // 独自フォントに設定
                            fontFamily   : 'DotGothic16'   , // Kalamフォント
                            fontSize     : "16px"    , 
                            color        : '#000000' , // フォントの色を黒に設定
                            }}>もういちど</Typography>
                        </Grid>

                        <Grid item xs = {4} align="center">
                            <Button 
                            onClick={handleSaveLocalStrage}>
                            <img
                                src    = {IMG_MASTER_BALL}
                                width  = "50px"
                                height = "50px"/>
                            </Button>
                            <Typography
                            sx={{
                            // 独自フォントに設定
                            fontFamily   : 'DotGothic16'   , // Kalamフォント
                            fontSize     : "16px"    , 
                            color        : '#000000' , // フォントの色を黒に設定
                            }}>ずかんにとうろくする</Typography>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>

            {/* 相手側を表示 */}
            {/* ポケモンの名前 */}
            <Grid item xs={12} align="left">
                <Typography
                    sx={{
                    // 独自フォントに設定
                    fontFamily   : 'DotGothic16' , // Kalamフォント
                    fontSize     : "13px"        , // フォントサイズ
                    color        : '#000000'     , // フォントの色を黒に設定
                    paddingLeft  : '10px'        , // 左側に10pxのパディングを追加して右にずらす
                    }}>{pokemonname}　Lv:{pokemonLevel}</Typography>
            </Grid>
            <Grid 
                item xs={12} 
                align="left"
                sx={{
                position     : 'absolute',
                top          : '25px',
                left         : '10px',
                width        : '50%',
                padding      : '0 5px',
                borderLeft   : '3px solid #000000', // 右から左に変更
                borderBottom : '3px solid #000000',
                borderRight  : 'none', // 左から右に変更
                borderTop    : 'none',
                borderRadius : '3px',
                '::before'   : {
                    content      : '""',
                    position     : 'absolute',
                    bottom       : '-1px', // 下枠線と重ならないように調整
                    right        : '0px',  // 左から右に変更
                    width        : 0,
                    height       : 0,
                    borderStyle  : 'solid',
                    borderWidth  : '10px 0 0 20px', // 直角三角形を反転
                    borderColor  : 'transparent transparent transparent #000000', // 三角形の色を右に設定
                },
                }}>
                <Grid item xs={12} align="left">
                <div
                    style={{
                    display: 'flex',
                    alignItems: 'center', // 縦方向の中央揃え
                    }}>
                    <Typography
                    sx={{
                        fontFamily   : 'DotGothic16', // フォント
                        fontSize     : '13px',        // フォントサイズ
                        color        : '#000000',     // フォントの色を黒に設定
                        
                    }}>
                        HP：
                    </Typography>
                    <div
                    style={{
                        width: '65%',
                        backgroundColor: '#e0e0e0',
                        borderRadius: '5px',
                        overflow: 'hidden',
                    }}>
                    <div
                        style={{
                        width           : `${pokemonHP}%`, // HPの割合（ここでは70%）
                        height          : '10px',          // HPバーの高さ
                        backgroundColor : '#000000',       // HPバーの色
                        borderRadius    : '5px 0 0 5px',   // 左端を角丸にする
                        }}>
                    </div>
                    </div>
                </div>
                </Grid>
            </Grid>
            {/* 残り時間表示 */}
            <Grid item xs={12} align="left"
                sx={{
                    position: 'absolute',
                    top: '50px',        // ★HP枠(25px)の下に出したいので少し下げる
                    left: '10px',
                    width: '50%',
                }}
                >
                <Typography
                    sx={{
                    fontFamily: 'DotGothic16',
                    fontSize: '13px',
                    color: '#000000',
                    }}
                >
                    のこり時間：{timeLeft}秒
                </Typography>
            </Grid>


            {/* ポケモン表示 */}
            <Grid 
                item xs={12} 
                align="right"
                style={{
                marginTop: '-20px',   // 上にずらす
                }}>
                <div 
                style={{
                    width: '120px',
                    height: '120px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: pokemonImage ? 'none' : 'none', // pokemonImageが空白の場合は枠線を表示しない
                }}>
                {pokemonImage && (
                    <img
                    src={pokemonImage}
                    width="100px"
                    height="100px"
                    alt="Pokemon"
                    style={{
                        border: 'none', // 画像の枠線を削除
                    }}
                    />
                )}
                </div>
            </Grid>

            {/* 自分側を表示 */}
            {/* タイプエラー表示領域*/}
            <Grid item xs={12} align="right" sx={{ mb: 0.5 }}>
            <Typography
                sx={{
                fontFamily : 'DotGothic16',
                fontSize   : '14px',
                color      : fontColor || "blue",
                height     : "18px",
                lineHeight : "18px",
                visibility : errType ? "visible" : "hidden",
                }}>
                {errType || " "}
            </Typography>
            </Grid>

            <Grid 
                item xs={12} 
                align="center"
                sx={{
                position     : 'absolute',
                top          : '150px',
                left         : '125px',
                width        : '50%',
                padding      : '0 5px',
                borderRight  : '3px solid #000000',
                borderBottom : '3px solid #000000',
                borderLeft   : 'none',
                borderTop    : 'none',
                borderRadius : '3px',
                '::before'   : {
                    content      : '""',
                    position     : 'absolute',
                    bottom       : '-1px', // 下枠線と重ならないように調整
                    left         : '0px',
                    width        : 0,
                    height       : 0,
                    borderStyle  : 'solid',
                    borderWidth  : '10px 20px 0 0', // 直角三角形を作成
                    borderColor  : 'transparent #000000 transparent transparent', // 三角形の色を設定
                },}}>
                <Typography
                sx={{
                    // 独自フォントに設定
                    fontFamily   : 'DotGothic16', // フォント
                    fontSize     : '14px',        // フォントサイズ
                    color        : '#000000',   // フォントの色を黒に設定
                }}>
                <Grid 
                    item xs={12} 
                    align="center"
                    sx={{
                    display: 'flex',
                    justifyContent: 'right', // 画像を中央揃え
                    }}>
                    {/* 中身のあるモンスターボールを表示 */}
                    {[...Array(5)].map((_, index) => (
                    <img
                        key={index}
                        src={IMG_BALL_ON}
                        alt={`Ball On ${index + 1}`}
                        width="17px"
                        height="17px"
                    />))}
                    {/* 中身のないモンスターボールを表示 */}
                    <img
                        src={IMG_BALL_NONE}
                        width="17px"
                        height="17px"
                    />
                </Grid>
                </Typography>
            </Grid>
            {/* 主人公のバック画像表示 */}
            <Grid 
                item xs={12} 
                align="left"
                className="slide-in-animation" // CSSクラスを追加
                style={{
                position: 'relative', // アニメーションのために必要
                marginTop: '-70px', // 上にずらす
                }}>
                <img
                    src={IMG_MAIN_CHAR_BG}
                    width="100px"
                    height="100px"
                    alt="Main Character"
                />
            </Grid>

            {/* メッセージ欄表示 */}
            <Grid 
                item xs={12} 
                align="center"
                sx={{
                border       : '3px solid #000000', // 枠線の太さと色を設定
                borderRadius : '5px',      // 角丸の半径を設定
                padding      : '0 5px',    // 上下0px、左右20pxの余白を設定
                top          : '180px',    // 縦位置を指定
                left         : '5px',      // 横位置を指定
                position     : 'absolute', // 絶対位置指定
                width        : '96%',      // 外枠の幅を指定
                height       : '30%',      // 外枠の高さを指定
                }}>
                <Typography
                sx={{
                    fontFamily : 'DotGothic16', // フォント
                    fontSize   : "14px", 
                    color      : '#000000',     // フォントの色を黒に設定
                }}
                tabIndex={0} // キーボードフォーカス可能にする
                >

                {/* タイピングの部分を表示 */}
                {resultWord ? (
                <span style={{ color: fontColor, fontSize: '14px' }}>{resultWord}</span>
                ) : (
                <>
                    {/* <div>{pokemonname}があらわれた！</div> */}
                    {/* カタカナ */}
                    <div style={{ fontSize: "23px" }}>{pokemonname}</div>

                    {/* ローマ字名 */}
                    <div style={{ fontSize: "25px", letterSpacing: "1px" }}>
                        {/* 入力済み（グレー） */}
                        <span style={{ color: "#888" }}>
                            {pokemonRomaji.slice(0, cursor)}
                        </span>

                        {/* 次に打つ1文字（赤・太字・下線無し） */}
                        <span style={{ color: "red" }}>
                            {pokemonRomaji[cursor] ?? ""}
                        </span>

                        {/* 残り（黒） */}
                        <span style={{ color: "#000" }}>
                            {pokemonRomaji.slice(cursor + 1)}
                        </span>
                    </div>
                </>
                )}

                </Typography>

            </Grid>
            </Paper>
            <Grid container spacing={2}>
                <Grid item xs={12} align="center"></Grid>
            </Grid>
        </Box>
    );
}

export default Typing
